// M2Stickers: width/height validation (min 4cm, max 299cm), live price and add-to-cart
export default function () {

    const $ = jQuery;

    let m2stickersValid = false;

    function validateStickerDimension($input) {
        const val = parseFloat($input.val());
        const isValid = !isNaN(val) && val >= 4 && val <= 299;
        $input.css('border-color', isValid ? '' : 'red');
        return isValid;
    }

    let m2stickersDebounce;

    $('[data-action="m2stickers_width"], [data-action="m2stickers_height"]').on('input blur', function () {
        const $width     = $('[data-action="m2stickers_width"]');
        const $height    = $('[data-action="m2stickers_height"]');
        const product_id = $('.wc__single-custom-m2stickers').data('product-id');

        const widthValid  = validateStickerDimension($width);
        const heightValid = validateStickerDimension($height);

        m2stickersValid = false;
        clearTimeout(m2stickersDebounce);

        if (widthValid && heightValid) {
            m2stickersDebounce = setTimeout(function () {
                $.ajax({
                    type: 'POST',
                    url: ajaxURL,
                    data: {
                        nonce: ajaxNonce,
                        action: 'calculate_m2stickers',
                        product_id: product_id,
                        width: parseFloat($width.val()),
                        height: parseFloat($height.val()),
                    },
                    beforeSend: function () {
                        $('.wc__single-product-price').addClass('updating');
                    },
                    success: function (response) {
                        if (response.success) {
                            $('.wc__single-product-price').html(response.data.price);
                            m2stickersValid = true;
                        }
                    },
                    complete: function () {
                        $('.wc__single-product-price').removeClass('updating');
                    }
                });
            }, 500);
        }
    });

    $('[data-action="add_custom_m2stickers_to_cart"]').on('click', function (e) {
        e.preventDefault();

        if (!m2stickersValid) {
            $('[data-action="m2stickers_width"], [data-action="m2stickers_height"]').trigger('blur');
            return;
        }

        const $btn       = $(this);
        const $width     = $('[data-action="m2stickers_width"]');
        const $height    = $('[data-action="m2stickers_height"]');
        const product_id = $('.wc__single-custom-m2stickers').data('product-id');

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                action: 'add_custom_m2stickers_to_cart',
                product_id: product_id,
                width: parseFloat($width.val()),
                height: parseFloat($height.val()),
                quantity: parseInt($('[name="product_quantity"]').val()) || 1,
            },
            beforeSend: function () {
                $btn.addClass('updating');
            },
            success: function (response) {
                if (response.success) {
                    window.location.href = response.data.cart_url;
                }
            },
            complete: function () {
                $btn.removeClass('updating');
            }
        });
    });

}
